import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { Route } from 'react-router-dom';
import { ResetForgottenPasswordViewModel } from '../../Screen/ResetForgottenPassword/ResetForgottenPasswordViewModel';
import { ResetForgottenPasswordViewController } from '../../Screen/ResetForgottenPassword/ResetForgottenPasswordController';


export class ResetForgottenPasswordCoordinator implements IndexCoordinatorDelegate {

    getRoute(): JSX.Element[] {
        return [
            this.routeResetForgottenPassword(),
        ];
    }

    private routeResetForgottenPassword(): JSX.Element {
        const viewModel = new ResetForgottenPasswordViewModel();
        return (
            <Route
                path="/:base/redefinir-senha/:token"
                exact={true}
                component={(props: any) => {
                    const token = props.match.params.token;
                    return (
                        <ResetForgottenPasswordViewController
                            navigation={props}
                            viewModel={viewModel}
                            token={token}
                            delegate={this}
                        />
                    );
                }}
            />
        );
    }
    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }
}
